import { useWizard } from "react-use-wizard";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../../..";
import buySteps from "../../buySteps";
import ChooseAreaStep from "../../../../../../../shared/wizard/steps/chooseAreaStep";
import useGeoPolygonByBuilding from "../../../../../../../../api/hooks/use-geo-polygon-by-building";
import { useEffect } from "react";

interface ISelectionByOwnBuyStep_2 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  data: number[] | null;
  buildingId: number | null;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnBuyStep_2 = ({
  isNextStepDisabled,
  buildingId,
  data,
  onChange,
  onReset,
}: ISelectionByOwnBuyStep_2) => {
  const { goToStep } = useWizard();

  const { trigger } = useGeoPolygonByBuilding();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_1);
    onReset(["rejectedLocationIds"]);
  };

  const handleNextStep = async () => {
    // по текущему билдингу с оценки получаем полигон
    if (buildingId) {
      const data = await trigger(buildingId);
      onChange([data.id], "rejectedLocationIds");
    }
    goToStep(buySteps.selectionSteps.buy.step_3);
  };

  return (
    <div>
      <ChooseAreaStep
        isNextStepDisabled={isNextStepDisabled}
        handleNextStep={handleNextStep}
        handlePrevStep={handlePrevStep}
        data={data}
        onChange={onChange}
      />
    </div>
  );
};

export default SelectionByOwnBuyStep_2;
